import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { API } from '@service/api';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';

/**
 * 节目选择器
 */
@Component({
  selector: 'content-selector',
  templateUrl: './content-selector.component.html',
})
export class ContentSelectorComponent implements OnInit {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<boolean>();

  title = '下发内容';
  loading = false;
  contentData: any[] = [];
  tableLoading = false;
  isAllChecked = false;

  constructor(private api: API, public http: _HttpClient, public msg: NzMessageService, public notify: NzNotificationService) {}

  ngOnInit(): void {}

  onAllCheck(ev: any): void {
    this.isAllChecked = ev;
    this.contentData = this.contentData.map((x: any) => (x.isChecked = ev));
  }

  onEachCheck(ev: any, i: number, item: any): void {
    item.isChecked = ev;
    if (ev) {
      let isAllChecked = true;
      this.contentData = this.contentData.map((x: any) => {
        if (!x.isChecked) {
          isAllChecked = false;
        }
        return x;
      });
      this.isAllChecked = isAllChecked;
    }
  }

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  submit(): void {
    this.refresh.emit(true);
  }
}
